import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemFms} from '../FM/FormChooseFm.jsx'
import {FormItemSs} from '../SS/FormChooseSs.jsx'
import {FormItemVms} from '../VM/FormChooseVm.jsx'
import Model from './ModelFc.mjs'

export const FormItemFcName = props => (
    <FormItemBizProp
        Model={Model}
        prop="fcName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemFcUserCode = props => (
    <FormItemBizProp
        Model={Model}
        prop="fcUserCode"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseFc(props) {
    return (
        <FormChooseDesign {...props} >
            <FormItemFms />
            <FormItemSs />
            <FormItemVms />
            <FormItemFcUserCode />
            <FormItemFcName />
        </FormChooseDesign>
    )
}
